import { BehaviorSubject } from 'rxjs';
class HaulerService {
    waysteAxios;
    // In Memory Cache for Hauler Account on Wayste
    static hauler = null;
    static haulerSubject = new BehaviorSubject(null);
    constructor(waysteAxios) {
        this.waysteAxios = waysteAxios;
    }
    wayste = {
        haulerObservable: HaulerService.haulerSubject.asObservable(),
        // This has to be a getter to ensure that the hauler is always up to date
        // used in the useCurrentAccount hook
        get currentHauler() {
            return HaulerService.hauler;
        },
        fetch: async () => {
            const { data } = await this.waysteAxios.mainInstance.get('/hauler');
            HaulerService.haulerSubject.next(data);
            HaulerService.hauler = data;
            return data;
        },
        update: async (input) => {
            const { data } = await this.waysteAxios.mainInstance.put('/hauler/hauler-admin', input);
            return data;
        },
        preferences: {
            query: async () => {
                const { data } = await this.waysteAxios.mainInstance.get('/hauler/preferences');
                return data;
            },
            fetch: async (id) => {
                const { data } = await this.waysteAxios.mainInstance.get(`/hauler/preference/${id}`);
                return data;
            },
            create: async (input) => {
                const { data } = await this.waysteAxios.mainInstance.post('/hauler/preference', input);
                return data;
            },
            createMany: async (input) => {
                const { data } = await this.waysteAxios.mainInstance.post('/hauler/preference/bulk', input);
                return data;
            },
        },
        sapData: {
            fetch: async () => {
                const { data } = await this.waysteAxios.mainInstance.get('/hauler/wayste/partner-data');
                return data;
            },
            update: async (input) => {
                const { data } = await this.waysteAxios.mainInstance.patch('/hauler/wayste/partner-data', input);
                return data;
            },
        },
        vendors: {
            query: async () => {
                const res = await this.waysteAxios.mainInstance.get('/hauler/vendor');
                return res.data;
            },
        },
    };
    // public readonly sapVendors = {
    // query: async (): Promise<PaginatedResult<Hauler.HaulerTransport>> => {
    // const res = await this.waysteAxios.mainInstance.get<PaginatedResult<Hauler.HaulerTransport>>('/hauler/sap-vendors');
    // return res.data;
    // },
    // };
    appAdmin = {
        updateHauler: async (id, hauler) => {
            const { data } = await this.waysteAxios.appAdminInstance.put(`/hauler/app-admin/${id}`, hauler);
            return data;
        },
    };
    waysteDashboard = {
        checkoutConfig: async () => {
            const { data } = await this.waysteAxios.mainInstance.get('/hauler/checkout');
            return data;
        },
    };
    async fetchCurrentHauler() {
        const { data } = await this.waysteAxios.mainInstance.get('/hauler');
        return data;
    }
    /**
     * @deprecated use wayste.update instead
     */
    async updateHauler(payload) {
        const res = await this.waysteAxios.mainInstance.put(`/hauler/hauler-admin`, payload);
        return res.data;
    }
    /////////////////////////////////////////////////////
    // YARD SECTION
    ////////////////////////////////////////////////////
    /**
     * @deprecated use yard.fetch instead
     */
    async fetchYards() {
        const res = await this.waysteAxios.mainInstance.get('/hauler/yards');
        return res.data.results;
    }
    /**
     * @deprecated use yard.create instead
     */
    async addYard(yard) {
        const res = await this.waysteAxios.mainInstance.post('/hauler/yard', yard);
        return res.data;
    }
    /**
     * @deprecated use yard.update instead
     */
    async updateYard(id, yard) {
        const res = await this.waysteAxios.mainInstance.put(`/hauler/yard/${id}`, yard);
        return res.data;
    }
    /**
     * @deprecated use yard.delete instead
     */
    async deleteYard(id) {
        const res = await this.waysteAxios.mainInstance.delete(`/hauler/yard/${id}`);
        return res.data;
    }
    yard = {
        query: async () => {
            const { data } = await this.waysteAxios.mainInstance.get('/hauler/yards');
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.waysteAxios.mainInstance.get(`/hauler/yard/${id}`);
            return data;
        },
        create: async (input) => {
            const { data } = await this.waysteAxios.mainInstance.post('/hauler/yard', input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.waysteAxios.mainInstance.put(`/hauler/yard/${id}`, input);
            return data;
        },
        delete: async (id) => {
            const { data } = await this.waysteAxios.mainInstance.delete(`/hauler/yard/${id}`);
            return data;
        },
    };
}
export default HaulerService;
//# sourceMappingURL=Hauler.service.js.map